import { ServerApiMapper } from '~commonInfra/utils/ServerModelHelper';
import { IListFetcher } from '~src/httpClient/fetchers/IListFetcher';
import { WebClientListResourceFetcher } from '~src/httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { IListResource } from '~src/httpClient/resources/Resource';
import { ResourceQuery } from '~src/httpClient/resources/ResourceQuery';
import { GetPublishedConnectionColumnsRequest } from '~src/publishedConnection/serverApi/requests/GetPublishedConnectionColumnsRequest';
import { IPublishedConnectionColumnInfo } from '~src/publishedConnectionTable/models/IPublishedConnectionTableInfo';

class PublishedConnectionColumnsResource implements IListResource<IPublishedConnectionColumnInfo> {

  private listFetcher: IListFetcher<IPublishedConnectionColumnInfo> = new WebClientListResourceFetcher(GetPublishedConnectionColumnsRequest, ServerApiMapper.publishedConnectionColumns);

  public all(): ResourceQuery<IPublishedConnectionColumnInfo> {
    return new ResourceQuery(this.listFetcher);
  }
}

export const PublishedConnectionColumns = new PublishedConnectionColumnsResource();
